export enum MpSelfEnrolmentFlowStepEnum {
  PersonalInformation,
  ContactInformation,
  LoginDetails
}
